import React from 'react';
import { List as AntList, ListProps as AntListProps } from 'antd';
import { createUseStyles } from 'react-jss';
import { ThemeType } from 'src/theming/jssTypes';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export interface ListProps<T = any> extends AntListProps<T> {
  className?: string;
}

const useStyles = createUseStyles((theme: ThemeType) => ({
  list: {
    '& .ant-list-item': {
      borderBottom: `${theme.border.width.sm} solid ${theme.color.semantic.border.soft}`,
      padding: `${theme.spacing[3]} ${theme.spacing[0]}`,
      color: theme.color.semantic.text.primary,
      '&:last-child': {
        borderBottom: 'none',
      },
    },
    '& .ant-list-item-meta-title': {
      color: theme.color.semantic.text.primary,
      fontSize: theme.typography.fontSize.md,
      fontWeight: theme.typography.fontWeight.medium,
      marginBottom: theme.spacing[1],
    },
    '& .ant-list-item-meta-description': {
      color: theme.color.semantic.text.tertiary,
      fontSize: theme.typography.fontSize.sm,
    },
    '& .ant-list-item-meta-avatar': {
      marginRight: theme.spacing[3],
    },
    '& .ant-list-header': {
      borderBottom: `${theme.border.width.sm} solid ${theme.color.semantic.border.soft}`,
      padding: `${theme.spacing[3]} ${theme.spacing[0]}`,
      color: theme.color.semantic.text.primary,
      fontWeight: theme.typography.fontWeight.semibold,
      fontSize: theme.typography.fontSize.md,
    },
    '& .ant-list-footer': {
      borderTop: `${theme.border.width.sm} solid ${theme.color.semantic.border.soft}`,
      padding: `${theme.spacing[3]} ${theme.spacing[0]}`,
    },
    '& .ant-list-empty-text': {
      color: theme.color.semantic.text.tertiary,
      padding: `${theme.spacing[6]} ${theme.spacing[0]}`,
      textAlign: 'center',
    },
    '& .ant-list-pagination': {
      marginTop: theme.spacing[4],
    },
    '&.ant-list-split .ant-list-item': {
      borderBottom: `${theme.border.width.sm} solid ${theme.color.semantic.border.soft}`,
    },
    '&.ant-list-bordered': {
      border: `${theme.border.width.sm} solid ${theme.color.semantic.border.primary}`,
      borderRadius: theme.radius.md,
    },
    '&.ant-list-bordered .ant-list-item': {
      paddingLeft: theme.spacing[4],
      paddingRight: theme.spacing[4],
    },
    '&.ant-list-bordered .ant-list-header, &.ant-list-bordered .ant-list-footer': {
      paddingLeft: theme.spacing[4],
      paddingRight: theme.spacing[4],
    },
  },
}));

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function ListComponent<T = any>({ className = '', ...rest }: ListProps<T>) {
  const classes = useStyles();
  return <AntList<T> {...rest} className={`${classes.list} ${className}`.trim()} />;
}

const List = Object.assign(ListComponent, {
  Item: AntList.Item,
});

export default List;
